<template>
    <div class="filter-bar" :class="[isShowQueryForm?'':'mb20']">
        <el-form
            v-show="isShowQueryForm"
            :inline="true"
            ref="formInline"
            v-model="tempQuery"
            class="demo-form-inline"
            @submit.native.prevent="onSubmit"
        >
            <el-form-item label=""  v-for="filter in filterOptions" :key="filter.name" :title="filter.display_name" v-show="customFilter.includes(filter.name)" class="mb10">
               <custom-input :label="filter.display_name" @append-click="()=>removeFilter(filter)">
                <BatchMultipleSelect
                    :key="'batchSelect'+filter.name"
                    :ref="'batchSelect'+filter.name"
                    v-if="filter.type=='search_multiple_select'"
                    :value="tempQuery[filter.name]"
                    :options="filter.options"
                    :loading="filter.loading"
                    :remote-method="(query)=>remoteBatchList(query,filter)"
                    @change="(val)=>changeBatchSearch(val,filter)"
                    @clear-all="(val)=>clearBatchSearch(val,filter)"
                    @change-all="(val)=>changeBatchSearchAll(val,filter)"
                    @batch-submit="(con)=>remoteBatchSubmit(con,filter)"
                    @show-options="showSelectOptions(filter)"
                    :title="filter.display_name"
                    batch-desc="输入或粘贴内容，每行一个"
                    :clearable="true"
                    :collapse-tags="true"
                    :placeholder="'输入关键字搜索'" />
                <ESelect
                    :key="'multipleSelect'+filter.name"
                    @change="changeSelect(filter,$event)"
                    class="select-tags-width"
                    v-if="filter.type=='multiple_select'"
                    v-model="tempQuery[filter.name]"
                    multiple
                    collapse-tags
                    filterable
                    clearable
                    reserve-keyword
                    :placeholder="filter.display_name+'：下拉多选'"
                    :style="{width:'170px'}">
                    <el-option value="all-option" v-if="(filter.options||[]).length>0&&((filter.options||[]).some(inner=>!tempQuery[filter.name].includes(inner.value)))">全选</el-option>
                    <el-option value="clear-option" v-if="(filter.options||[]).length>0&&((filter.options||[]).every(inner=>tempQuery[filter.name].includes(inner.value)))">取消全选</el-option>
                    <el-option :label="option.name" :value="option.value" v-for="option in filter.options||[]" :key="option.value"></el-option>
                </ESelect>
                <ESelect
                    :key="'select'+filter.name"
                    @change="changeSelect(filter,$event)"
                    v-if="filter.type=='select'"
                    v-model="tempQuery[filter.name]"
                    filterable
                    clearable
                    :placeholder="filter.display_name+'：下拉选择'"
                    :style="{width:'170px'}">
                    <el-option :label="option.name" :value="option.value" v-for="option in filter.options||[]" :key="option.value"></el-option>
                </ESelect>
                <el-date-picker
                    :key="'date'+filter.name"
                    v-else-if="filter.type=='date'"
                    v-model="tempQuery[filter.name]"
                    style="width: 232px"
                    type="daterange"
                    align="center"
                    unlink-panels
                    value-format="yyyy-MM-dd"
                    range-separator="~"
                    :start-placeholder="filter.display_name+''"
                    :end-placeholder="filter.display_name"
                    class="ver-middle">
                </el-date-picker>

               <template #append>
                 <div v-if="filter.default_check!='1'" class=" pointer text-color-error" @click="removeFilter(filter)" title="删除">
                    <span class="relative" >x</span>
                </div>
               </template>
                </custom-input>
            </el-form-item>
            <el-form-item class="mb10">
                <FilterPopSelect :list="listMap" :value="customFilter" @change="changeFilter"/>
            </el-form-item>
            <el-divider class="mt0 mb10" />
            <el-form-item class="mb10">
                <el-button type="primary" @click="onSubmit" :loading="submitLoading">查询</el-button>
                <el-button @click="resetForm('formInline')" :loading="clearLoading">清空筛选</el-button>
            </el-form-item>
        </el-form>

        <SplitBar :direction="isShowQueryForm?'up':'down'" @toggle="toggleShowQueryForm"/>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex';
    import API from '@/api/marketManage/apple/index';
    import FilterPopSelect from '../components/filterPopSelect';
    import util from '@/libs/utils';
    import BatchMultipleSelect from '@/components/BatchMultipleSelect';
    import SplitBar from './splitBar';
    import { uniq } from 'lodash';



    export default {
        name: "Query",
        components:{
            FilterPopSelect,
            BatchMultipleSelect,
            SplitBar,
        },
        props:{
            list:Array,
            page:String,
        },
        data(){
            return {
                formInline: {},
                customFilter:[],
                tempQuery:{},
                filterOptions:[],
                submitLoading:false,
                clearLoading:false,
                isShowQueryForm:true,
            }
        },
        computed:{
            ...mapGetters(['apple_list_page_query','apple_common_config','user_id']),
            searchApiType(){
                let apiType = '';
                if(this.page=='apple_promotion_manage_org'){
                    apiType = 'getOrgSearchList';
                }else if(this.page=='apple_promotion_manage_campaign'){
                    apiType = 'getCampaignSearchList';
                }else if(this.page=='apple_promotion_manage_adgroup'){
                    apiType = 'getAdGroupSearchList';
                }else if(this.page=='apple_promotion_manage_keyword'){
                    apiType = 'getKeywordSearchList';
                }else if(this.page=='apple_promotion_manage_search_term'){
                    apiType = 'getSearchTermSearchList';
                }else if(this.page=='apple_promotion_manage_negative_keyword'){
                    apiType = 'getNegativeKeywordSearchList';
                }
                return apiType;
            },
            listMap(){
                let listData = this.list||[];
                return listData.filter(item=>{
                    let config = item.config||{};
                    return !!config.type;
                })
            },
        },
        created(){
            window.addEventListener('popstate', ()=>{this.handleHistory()});
        },
        mounted(){
            /* 获取自定义筛选字段 */
            this.getCustomFilter();
            console.log('mounted',this.apple_common_config);
            let commonConfig = this.apple_common_config;
            this.isShowQueryForm = commonConfig.search_filter_toggle=='1';
        },
        beforeDestroy(){
            window.removeEventListener('popstate', ()=>{this.handleHistory()});
        },
        watch: {
            list: {
                handler(val) {
                    if(Array.isArray(val)&&val.length>0){
                        let listData = this.list||[];
                        this.filterOptions = listData.map(item=>{
                            let config = item.config||{};
                            return {
                                display_name:item.display_name,
                                name:item.name,
                                type:config.type,
                                options:[],
                                placeholder:item.display_name||'请选择',
                                checked:false,
                                loading:false,
                                allOptions:[],
                                default_check:item.default_check,
                            };
                        });
                        this.getFilterOptions().then((res)=>{
                            if(listData.length>0){
                                this.initTempQuery();
                                this.$emit("query-click", {...this.formInline});
                            }else if(res===true){
                                this.$emit("query-click", {...this.formInline});
                            }
                        })
                    }
                },
                deep: true,
                immediate: true
            },
        },

        methods: {
            handleHistory(){
                let router_name = this.$route.name;
                let localQuery = {};
                try {
                    let localData = JSON.parse(localStorage.getItem('AppleQueryRestoreData'))||{};
                    let submitQuery = localData.tabName==this.$route.name?localData?.value||{}:{};

                    localQuery = {
                        org_id:submitQuery.org_id||[],
                        org_name:submitQuery.org_name||[],
                        campaign_id:submitQuery.campaign_id||[],
                        campaign_name:submitQuery.campaign_name||[],
                        adgroup_id:submitQuery.adgroup_id||[],
                        adgroup_name:submitQuery.adgroup_name||[],
                    };
                }catch (e) {
                    localQuery = {};
                }

                if(router_name=='apple_org'){
                    this.$store.commit('apple/RESET_LIST_PAGE_QUERY');
                    localStorage.removeItem('AppleQueryRestoreData');
                }else if(router_name=='apple_campaign'){
                    if(router_name=='apple_keyword'||router_name=='apple_search_term'||router_name=='apple_negative_keyword'){
                        this.$store.commit('apple/CLEAR_ADGROUP_LIST_PAGE_QUERY');
                        let temData = Object.assign({},localQuery,{
                            adgroup_id:[],
                            adgroup_name:[],
                        });
                        localStorage.setItem('AppleQueryRestoreData',JSON.stringify({
                            value:temData,
                            tabName:this.$route.name,
                        }));
                    }
                    this.$store.commit('apple/CLEAR_CAMPAIGN_LIST_PAGE_QUERY');
                    let temData = Object.assign({},localQuery,{
                        campaign_id:[],
                        campaign_name:[],
                    });
                    localStorage.setItem('AppleQueryRestoreData',JSON.stringify({
                        value:temData,
                        tabName:this.$route.name,
                    }));
                }else if(router_name=='apple_adgroup'){
                    this.$store.commit('apple/CLEAR_ADGROUP_LIST_PAGE_QUERY');
                    let temData = Object.assign({},localQuery,{
                        adgroup_id:[],
                        adgroup_name:[],
                    });
                    localStorage.setItem('AppleQueryRestoreData',JSON.stringify({
                        value:temData,
                        tabName:this.$route.name,
                    }));
                }

                let $route = this.$route;
                let query = $route.query;
                if(Object.keys(query).length>0){
                    this.$router.replace({
                        name:$route.name,
                    })
                }
            },
            getFilterOptions(){
                let fieldList = this.filterOptions.filter(item=>item.type=='multiple_select'||item.type=='select');
                let queryList = fieldList.map(item=>item.name);
                if(!this.searchApiType){
                    return new Promise((resolve,reject)=>{reject()});
                }else if(queryList.length<=0){
                    return new Promise((resolve,reject)=>{resolve(true)});
                }
                // if(queryList.length<=0||!this.searchApiType) return new Promise((resolve,reject)=>{reject()});

                return API[this.searchApiType]({
                    search:'',
                    search_type:queryList.join(','),
                    batch_search:[],
                }).then(res => {
                    let resData = res.data || {};
                    queryList.forEach(item=>{
                        let listData = resData[item]||{};
                        let resList = listData.list||[];
                        let filterItem = this.filterOptions.find(inner=>inner.name==item);
                        filterItem.loading = false;
                        filterItem.options = resList.map(item=>{
                            return {
                                name:item.name,
                                value:item.id,
                            }
                        });
                        filterItem.options.forEach(item=>{
                            if(!filterItem.allOptions.find(inner=>inner.name==item.name&&inner.value==item.value)){
                                filterItem.allOptions.push({...item});
                            }
                        })
                    })
                });
            },
            initTempQuery(isClear){
                let localQuery = {};
                let localQueryArr = [];
                try {
                    let localData = JSON.parse(localStorage.getItem('AppleQueryRestoreData'))||{};
                    localQuery = localData.tabName==this.$route.name?localData?.value||{}:{};
                    console.log('initTempQuery',localData.tabName,this.$route.name,localQuery)
                }catch (e) {
                    localQuery = {};
                }
                let preRouteQuery = this.$route.query||{};
                let keys = uniq(Object.keys(localQuery).concat(['org_id','org_name','campaign_id','campaign_name','adgroup_id','adgroup_name']));
                let routeQuery = {};
                keys.forEach(item=>{
                    if(localQuery[item]?.length>0){
                        routeQuery[item] = localQuery[item];
                        localQueryArr.push(item);
                    }else if(preRouteQuery[item]?.length>0){
                        routeQuery[item] = preRouteQuery[item];
                    }else {
                        // routeQuery[item] = [];
                    }
                });

                let routeKeys = Object.keys(routeQuery);
                let storeQueryData = this.apple_list_page_query;
                this.filterOptions.forEach(item=>{
                    let routeVal = null;
                    if(isClear){
                        routeVal = [];
                    }else{
                        let itemVal = routeQuery[item.name];
                        if(Array.isArray(itemVal)&&itemVal.length>0){
                            routeVal = itemVal;
                        }else if((typeof itemVal=='string')&&itemVal.length>0){
                            routeVal = [itemVal];
                        }else if(storeQueryData[item.name]&&storeQueryData[item.name].length>0){
                            routeVal = storeQueryData[item.name];
                        }else{
                            routeVal = [];
                        }
                    }

                    if(item.type=='search_multiple_select'){
                        this.$set(this.tempQuery,item.name,routeVal);
                        this.$set(this.formInline,item.name,routeVal);
                        if(localQueryArr.includes(item.name)){
                            routeVal.forEach(inner=>{
                                this.remoteBatchList(inner,item);
                            })
                        }
                    }else if(item.type=='multiple_select'){
                        /* 针对hungry客户特殊处理状态筛选项（进筛选启动） */
                        let isHungryAccount = this.user_id=='940';

                        /* 广告系列页面-状态列-默认筛选 非删除 */
                        if(this.page=='apple_promotion_manage_campaign'&&item.name=='campaign_display_status'&&routeVal.length<=0){
                            let defaultVal = (item.options||[]).map(inner=>inner.value).filter(inner=>{
                                if(isHungryAccount) return inner=='RUNNING';
                                return inner!='DELETED';
                            });
                            this.$set(this.tempQuery,item.name,defaultVal);
                            this.$set(this.formInline,item.name,defaultVal);
                        }else if(this.page=='apple_promotion_manage_adgroup'&&item.name=='adgroup_display_status'&&routeVal.length<=0){
                            /* 广告组页面-状态列-默认筛选 非删除 */
                            let defaultVal = (item.options||[]).map(inner=>inner.value).filter(inner=>{
                                if(isHungryAccount) return inner=='RUNNING';
                                return inner!='DELETED';
                            });
                            this.$set(this.tempQuery,item.name,defaultVal);
                            this.$set(this.formInline,item.name,defaultVal);
                        }else if(this.page=='apple_promotion_manage_keyword'&&item.name=='keyword_display_status'&&routeVal.length<=0){
                            /* 关键词页面-状态列-默认筛选 非删除 */
                            let defaultVal = (item.options||[]).map(inner=>inner.value).filter(inner=>{
                                if(isHungryAccount) return inner=='RUNNING';
                                return inner!='DELETED';
                            });
                            this.$set(this.tempQuery,item.name,defaultVal);
                            this.$set(this.formInline,item.name,defaultVal);
                        }else{
                            this.$set(this.tempQuery,item.name,routeVal);
                            this.$set(this.formInline,item.name,routeVal);
                        }
                    }else if(item.type=='select'){
                        this.$set(this.tempQuery,item.name,Array.isArray(routeVal)?routeVal.join(','):routeVal);
                        this.$set(this.formInline,item.name,Array.isArray(routeVal)?routeVal.join(','):routeVal);
                    }else if(item.type=='date'){
                        this.$set(this.tempQuery,item.name,routeVal);
                        this.$set(this.formInline,item.name,routeVal);
                    }
                });

                routeKeys.forEach(item=>{
                    let actionItem = this.filterOptions.find(inner=>inner.name==item);
                    if(!actionItem){
                        this.$set(this.formInline,item,routeQuery[item]);
                    }
                })
            },
            onSubmit() {
                this.filterOptions.forEach(item=>{
                    this.formInline[item.name] = this.tempQuery[item.name];
                });
                this.submitLoading = true;
                setTimeout(()=>{
                    this.submitLoading = false;
                },1000);
                this.$emit("query-click", {...this.formInline})
            },
            resetForm(formName) {
                console.log('reset',formName,this.$refs);
                // this.$refs[formName].resetFields();
                this.clearLoading = true;
                this.initTempQuery(true);
                this.$nextTick(()=>{
                    this.$emit("query-click", {...this.formInline},true);
                })
            },
            changeFilter(list){
                console.log('changeFilter',list);
                this.customFilter = [...list];

                API.editCustomFilter({
                    field_type:this.page+'_filter',
                    fields:list.map(item=>{
                        let actionItem = this.list.find(inner=>inner.name==item);
                        return {
                            name:item,
                            label:actionItem.display_name,
                        };
                    })
                }).then(res=>{
                    console.log('editCustomFilter',res);
                });

                this.filterOptions.forEach(item=>{
                    if(!list.includes(item.name)){
                        this.tempQuery[item.name] = [];
                    }
                })
            },
            getCustomFilter(){
                return API.getCustomFilter({
                    field_type:this.page+'_filter',
                }).then(res=>{
                    console.log('getCustomFilter',res);
                    let resData = res.data||[];
                    this.customFilter = resData.map(item=>item.name);
                })
            },
            removeFilter(filter){
                console.log('removeFilter',filter);
                this.tempQuery[filter.name] = [];
                let index = this.customFilter.findIndex(item=>item==filter.name);
                if(index!=-1){
                    this.customFilter.splice(index,1);
                }
                API.editCustomFilter({
                    field_type:this.page+'_filter',
                    fields:this.customFilter.map(item=>{
                        let actionItem = this.filterOptions.find(inner=>inner.name==item)||{};
                        return {
                            name:actionItem.name,
                            label:actionItem.display_name,
                        }
                    }),
                });
            },
            remoteFilter(query,filter){
                let filterItem = this.filterOptions.find(item=>item.name==filter.name);
                if(!filterItem||!this.searchApiType) return;
                if(!query){
                    return filterItem.options = [];
                }
                filterItem.loading = true;

                API[this.searchApiType]({
                    search:query,
                    search_type:filter.name,
                    batch_search:[],
                }).then(res => {
                    let resData = res.data || {};
                    console.log('res',res);
                    let listData = resData[filter.name]||{};
                    let resList = listData.list||[];
                    filterItem.loading = false;
                    filterItem.options = resList.map(item=>{
                        return {
                            name:item.name,
                            value:item.id,
                        }
                    })
                    filterItem.options.forEach(item=>{
                        if(!filterItem.allOptions.find(inner=>inner.value==item.value&&inner.name==item.name)){
                            filterItem.allOptions.push({...item});
                        }
                    })
                });
            },
            changeSelect(item,val){
                console.log('changeSelect',item,val);
                if(val.includes('all-option')){
                    this.tempQuery[item.name] = item.options.map(item=>item.value);
                }else if(val.includes('clear-option')){
                    item.options.forEach(item1=>{
                        if(this.tempQuery[item.name].includes(item1.value)){
                            let index = this.tempQuery[item.name].findIndex(inner=>inner==item1.value);
                            if(index!=-1){
                                this.tempQuery[item.name].splice(index,1);
                            }
                        }
                    });
                    this.$nextTick(()=>{
                        let clearIndex = this.tempQuery[item.name].findIndex(inner=>inner=='clear-option');
                        if(clearIndex!=-1){
                            this.tempQuery[item.name].splice(clearIndex,1);
                        }
                    });
                }else{
                    this.tempQuery[item.name] = val;
                }
            },
            getQueryData(){
                return util.deepClone(this.formInline);
            },
            setSubmitLoading(val){
                this.submitLoading = !!val;
            },
            setClearLoading(val){
                this.clearLoading = !!val;
            },

            remoteBatchList(query,filter){
                console.log('remoteBatchList',query,filter);
                if (query !== ''&&this.searchApiType) {


                    filter.loading = true;
                    API[this.searchApiType]({
                        search:query,
                        search_type:filter.name,
                    }).then(res=>{
                        let resData = res.data||{};
                        let listData = resData[filter.name]||{};
                        let resList = listData.list||[];
                        filter.loading = false;
                        filter.options = resList.map(item=>{
                            return {
                                name:item.name,
                                value:item.id,
                            }
                        });
                        filter.options.forEach(item=>{
                            if(!filter.allOptions.find(inner=>inner.value==item.value&&inner.name==item.name)){
                                filter.allOptions.push({...item});
                            }
                        })
                    },err=>{
                        filter.loading = false;
                        console.log('getAccountOptionList err',err);
                        filter.options = [];
                    })
                } else {
                    filter.options = [];
                }
            },
            changeBatchSearch(val,filter){
                console.log('changeBatchSearch',val,filter);
                // this.tempQuery[filter.name] = [...val];
                this.$set(this.tempQuery,filter.name,[...val]);
            },
            clearBatchSearch(val=[],filter){
                val.forEach(item=>{
                    let index = this.tempQuery[filter.name].findIndex(inner=>inner==item);
                    if(index!=-1){
                        this.tempQuery[filter.name].splice(index,1);
                    }
                })
            },
            changeBatchSearchAll(val,filter){
                console.log('changeBatchSearchAll',val,filter);
                // this.tempQuery[filter.name] = [...val];
                let oldVal = this.tempQuery[filter.name];
                let newVal = [...val].filter(item=>!oldVal.includes(item));
                this.$set(this.tempQuery,filter.name,oldVal.concat(newVal));
            },
            showSelectOptions(filter){
                let value = this.tempQuery[filter.name]||[];
                filter.options = value.map(item=>{
                    let actionItem = filter.allOptions.find(inner=>inner.value==item);
                    return {
                        name:actionItem?actionItem.name:item,
                        value:item,
                    }
                })
            },
            remoteBatchSubmit(con,filter){
                console.log('remoteBatchSubmit',con,filter);
                if(!con||!this.searchApiType) return;

                API[this.searchApiType]({
                    search_type:filter.name,
                    batch_search:con,
                }).then(res=>{
                    let $refSelect = this.$refs['batchSelect'+filter.name][0];
                    $refSelect.hideBatchLoading();

                    let resData = res.data || {};
                    let listData = resData[filter.name]||{};
                    let successList = listData.list||[];
                    let errList = listData.err_list||[];

                    if(errList.length>0){
                        let htmlStr = `<div style="max-height: 150px;overflow: auto;">`;
                        htmlStr += '<p>未找到以下内容，请核实，是否需要剔除未找到的内容?</p>';
                        htmlStr += '<p class="font12px">'+(errList.join('、'))+`</p></div>`;
                        this.$confirm(htmlStr, '提示', {
                            confirmButtonText: '剔除',
                            cancelButtonText: '关闭',
                            dangerouslyUseHTMLString: true,
                            type: 'error',
                            customClass:'batch-err-tips-modal',
                            width:'500',
                        }).then(()=>{
                            $refSelect.hideBatchModal();


                            (successList||[]).forEach(item=>{
                                if(!filter.options.find(inner=>inner.id==item.id)){
                                    filter.options.push({
                                        name:item.name,
                                        value:item.id,
                                    });
                                }
                                if(!filter.allOptions.find(inner=>inner.name==item.name&&inner.value==item.value)){
                                    filter.allOptions.push({...item});
                                }
                                if(!this.tempQuery[filter.name].includes(item.id)){
                                    this.tempQuery[filter.name].push(item.id);
                                }
                            })
                        });
                    }else{

                        $refSelect.hideBatchModal();
                        (successList||[]).forEach(item=>{
                            if(!filter.options.find(inner=>inner.id==item.id)){
                                filter.options.push({
                                    name:item.name,
                                    value:item.id,
                                });
                            }
                            if(!filter.allOptions.find(inner=>inner.name==item.name&&inner.value==item.value)){
                                filter.allOptions.push({...item});
                            }
                            if(!this.tempQuery[filter.name].includes(item.id)){
                                this.tempQuery[filter.name].push(item.id);
                            }
                        })
                    }
                },err=>{
                    console.log('batch error', err);
                    let $refSelect = this.$refs['batchSelect'+filter.name][0];
                    $refSelect.hideBatchLoading();
                    this.$message.error(err.info||'请求有误');
                })
            },
            toggleShowQueryForm(){
                this.isShowQueryForm = !this.isShowQueryForm;
                let commonConfig = this.apple_common_config;
                API.editCommonConfig({
                    dynamic_day_type:commonConfig.dynamic_day_type,
                    search_filter_toggle:this.isShowQueryForm?'1':'0',
                });
                this.$store.commit('apple/SET_COMMON_CONFIG',{
                    dynamic_day_type:commonConfig.dynamic_day_type,
                    search_filter_toggle:this.isShowQueryForm?'1':'0',
                });

            },
        },
    }
</script>

<style lang="scss" scoped>
    .filter-bar{
        position: relative;
        /*background-color: #f8f8f9;*/
        /*padding: 20px 20px 0;*/
        /*border-radius: 5px;*/
        /*margin-bottom: 20px;*/


        background-color: #fff;
        padding: 8px 15px 0;
        border:1px solid #e8eaec;
        border-radius:3px;
        margin-bottom:10px;

        ::v-deep .el-input__inner{
            border-radius: 3px 0 0 3px;
        }




        ::v-deep .custom-filter .el-input{
            border-top-right-radius: 0;
            border-bottom-right-radius: 0;
            .el-input__inner{
                border-top-right-radius: 0;
                border-bottom-right-radius: 0;
            }
        }

        .remove-btn{
            display: inline-block;
            background-color: #FFF;
            border: 1px solid #DCDFE6;
            border-left: none;
            width: 20px;
            text-align: center;
            border-radius: 0 4px 4px 0;
            position: relative;
            z-index: 1;
            height: 32px;
            line-height: 32px;
            top: 2px;
        }

        ::v-deep .custom-filter .el-select__tags-text{
            max-width: 50px;
        }

        .mb10{
            margin-bottom: 10px;
        }
        .mt0{
            margin-top: 0;
        }


        .handle-bar{
            position: absolute;
            width: 50px;
            height: 30px;
            background-color: red;
            left: 50%;
            cursor: pointer;
            &.handle-bar-up{
                bottom: 0;
            }
        }

        &.mb20{
            margin-bottom: 20px;
        }

    }
</style>
